// extracted by mini-css-extract-plugin
module.exports = {"buttonDots":"_3T6wn","dotsWrapper":"cywGR","next":"_3PVgj","pre":"_1QGyM","active":"_3iiQ8","navBtn":"vZgjf"};